import React from "react";
import { withRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import swal from "sweetalert";
import { Modal, Button, Card, Row, Col, Form } from "react-bootstrap";
import { HomeIcon, PLusIcon } from "../../assets/Icons";
import Search from "../../common/Search";
import { connect } from "react-redux";
import AssignedWorkedFlow from "./AssignedWorkedFlowMobile";
import TableSkelton from "../../skeltonloader/TableSkelton";
import NoDataFound from "../../common/NoDataFound";
import CloneModal from "../../common/CloneModal";
import BackBtn from "../../common/BackBtn";
import ScheduleRecurrenceModal from "../../common/ScheduleModel";

const calculateLatestVersion = (versionList) => {
  const versionCopyArray = [...versionList];
  versionCopyArray.sort((a, b) => b.id - a.id);
  const latestVersion = versionCopyArray[0]?.version;
  return Number((latestVersion + 0.1).toFixed(2));
};

class ListWorkflowVersion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      allWorkFlowList: [],
      workflowDetails: {
        title: "",
      },
      releaseNewVersion: false,
      description: "",
      version: "",
      lastversion: 0,
      selectedVersionId: undefined,
      errors: {
        version: "",
      },
      message: "",
      lastpublished: null,

      minutes: [],
      casualModal: false,
      casualInput: "Daily",
      Sunday: true,
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      schedule: null
    };
  }

  openModal = () => this.setState({ showModal: true });

  closeModal = () => this.setState({ showModal: false });


  componentDidMount() {
    let arr = [];
    for (let i = 1; i < 60; i++) arr.push(i);
    this.setState({ minutes: arr });

    // if (
    //   sessionStorage.getItem("selected_workflow") == null ||
    //   sessionStorage.getItem("selected_workflow") == undefined ||
    //   sessionStorage.getItem("selected_workflow") === ""
    // ) {
    //   window.location.href = "/create/workflow";
    //   return;
    // }
    this.getTotalList();
    this.getWorkflowSchedule();
    this.setState({ workflowDetails: JSON.parse(sessionStorage.getItem("selected_workflow_description")) });
  }

  getWorkflowSchedule = async () => {
    const workflow_id = sessionStorage.getItem("selected_workflow");
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString()
    };

    let { data } = await axios.get(`${SERVER_IP}/workflow/schedule/list/${workflow_id}`, { withCredentials: true, headers: headers });

    _this.setState({
      schedule: data.data,
    });
  };

  getTotalList = () => {
    var data = {
      workflow_id: sessionStorage.getItem("selected_workflow"),
    };
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflowVersions`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          if (Array.isArray(response.data.workflow_version)) {
            _this.setState({
              allWorkFlowList: response.data.workflow_version,
              message: response.data.workflow_version.length === 0 ? "No Record Found." : "",
            });
          }
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.getTotalList();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  };
  onChangeInput = (e) => {
    e.preventDefault();

    this.checkRequirement(e.target.name, e.target.value);
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageChange = (e) => {
    e.preventDefault();
    if (!e.target.files[0]) {
      return;
    }
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        logo: reader.result,
      });
    };
  };

  releaseNewVersion = () => {
    var version = 0;
    var lastpublished = null;
    if (this.state.allWorkFlowList.length > 0) {
      version = this.state.allWorkFlowList[this.state.allWorkFlowList.length - 1].version;
      var lastpublishedtemp = this.state.allWorkFlowList.find((x) => x.publish_status == 1);
      if (lastpublishedtemp) {
        lastpublished = lastpublishedtemp.version;
      }
    }
    this.setState({ releaseNewVersion: true, lastversion: version, lastpublished: lastpublished });
  };

  taskCreate = (list) => {
    sessionStorage.setItem("version_info", JSON.stringify(list));
    if (list.is_published == 0) {
      window.location.href = "/create/task";
    } else {
      window.location.href = "/create/publishedtask";
    }
  };
  checkRequirement = (name, value) => {
    let errors = this.state.errors;

    switch (name) {
      case "version":
        errors.version =
          value.split(".").length != 2
            ? "Please fill the correct version. e.g 1.0. "
            : value.split(".")[0] == "" || value.split(".")[1] == ""
              ? "Please fill the correct version. e.g 1.0."
              : this.state.lastversion < value
                ? ""
                : "Version Must Be Greater Then Old Version. ";
        break;

        break;
      default:
        break;
    }

    this.setState({ errors });
  };
  submitRelease = (e, makeClone = false) => {
    e.preventDefault();
    Object.keys(this.state.errors).map((list, index) => this.checkRequirement(list, this.state[list]));
    this.checkRequirement(e);
    if (makeClone || validateForm(this.state.errors)) {
    } else {
      swal({
        title: "Invalid Input..!!",
        text: "Enter a valid value (e.g., 1.0, 1.1, 1.2, 1.3).",
        icon: "error",
      });
      return;
    }

    var data = {
      sid: ud.main_id,
      workflow_id: sessionStorage.getItem("selected_workflow"),
      target_version_id: this.state.selectedVersionId,
      destination_version: makeClone ? calculateLatestVersion(this.state.allWorkFlowList) : this.state.version,
    };
    if (data.target_version_id === undefined) {
      swal("Please Select The Version.");
      return;
    }
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflowVersionNew`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            _this.setState({ releaseNewVersion: false, version: "", selectedVersionId: undefined });
            _this.getTotalList();
            if (makeClone) {
              _this.closeCloneModal();
            }
            swal("Success", response.data.message, "success");
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.submitRelease();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };

  radioVersionSelect = (e) => {
    this.setState({ selectedVersionId: e.target.value });
  };

  openCloneModal = (targetVersionId) => {
    this.setState({ showCloneModal: true, selectedVersionId: targetVersionId });
  };

  closeCloneModal = () => {
    this.setState({ showCloneModal: false, selectedVersionId: undefined });
  };

  render() {
    const { errors, workflowDetails } = this.state;
    const { user } = this.props;
    const { isMobile } = user;
    return (
      <div>
        {!isMobile ? (
          <>
            <div className="xp-breadcrumbbar">
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <h4 className="xp-page-title">
                    <BackBtn /> Workflow Version List
                  </h4>
                </div>
              </div>
              <div className="row ">
                <div className="col-md-12 col-lg-12">
                  <div className="xp-breadcrumb gradient-border">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a onClick={() => this.props.history.push("/dashboard")}>
                          <i>
                            <HomeIcon />
                          </i>
                        </a>
                      </li>
                      <li className="breadcrumb-item">
                        <a onClick={() => this.props.history.push("/create/workflow")}>Workflow Management</a>
                      </li>

                      <li className="breadcrumb-item active">
                        <a>{workflowDetails?.sopData?.sop_type_name || "Workflow type"}</a>
                      </li>

                      {/* <li className="breadcrumb-item">Workflow Demo</li> */}
                    </ol>
                  </div>
                </div>
                {/* <div className="col-md-4 col-lg-4 filter-tab">
                  <Search />
                </div> */}
              </div>
            </div>

            <div className="xp-contentbar p-30">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card document_gradient_border padding-0 border-before-15 m-b-30">
                    <div className="card-header dv-center space-between">
                      <h5 className="card-title text-black mb-0">{this.state.workflowDetails.title}</h5>
                      <div>
                        <button className="btn btn-white btn-lg rounded" onClick={this.releaseNewVersion}>
                          <i className="versionplus"> <PLusIcon /> </i>
                          Create New Version
                        </button>
                        {" "}
                        <button className="btn btn-white btn-lg rounded" onClick={this.openModal}>
                          <i className="fa fa-clock-o"></i>
                          {this.state.schedule ? " Update": " Create"} Schedule
                        </button>


                      </div>
                    </div>

                    <div className="card-body">
                      <div className="table-responsive">
                        {/* {this.state.allWorkFlowList.length === 0 ? (
                          this.state.message === "" ? (
                            // loader
                            <div className="lds-spinner">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          ) : (
                            // loader-end
                            <div className="message-no-record"> {this.state.message} </div>
                          )
                        ) : null} */}
                        <table className="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th className="text-center" style={{ width: "5%" }}>
                                No
                              </th>
                              <th className="text-center">Version</th>

                              {/* <th>Description</th> */}
                              <th className="text-center">Date</th>
                              <th className="text-center">Time</th>
                              <th className="text-center" style={{ width: "15%" }}>
                                Publish Status
                              </th>
                              <th className="text-center" style={{ width: "15%" }}>
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.allWorkFlowList.length === 0 ? (
                              this.state.message === "" ? (
                                // Loader row
                                <TableSkelton rowCount={3} colCount={6} />
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center text-muted">
                                    <NoDataFound headText={this.state.message} />
                                  </td>
                                </tr>
                              )
                            ) : (
                              this.state.allWorkFlowList.map((list, index) => (
                                <tr key={index}>
                                  <td className="text-center">{index + 1}</td>
                                  <td className="text-center">{JSON.stringify(list.version)}</td>
                                  <td className="text-center">{list.publishDate}</td>
                                  <td className="text-center">{list.publishTime}</td>
                                  <td className="text-center">
                                    {list.publish_status == 1 ? (
                                      <span className="text-success">Live</span>
                                    ) : (
                                      <span className="text-danger">Inactive</span>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    <div className="tabledit-toolbar">
                                      <button
                                        type="button"
                                        onClick={() => this.taskCreate(list)}
                                        className="btn btn-light btn-block rounded"
                                        title="Task"
                                      >
                                        Manage task
                                      </button>
                                      <Button
                                        className="btn btn-light btn-block rounded"
                                        // onClick={() => this.setState({ casualModal: true })}
                                        onClick={() => this.openCloneModal(list.id)}
                                        style={{ padding: "7px 17px" }}
                                      >
                                        Clone Workflow
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>

                      <CloneModal
                        show={this.state.showCloneModal}
                        onClose={this.closeCloneModal}
                        cloneVersion={this.submitRelease}
                      />

                      <Modal
                        show={this.state.casualModal}
                        onHide={() => this.setState({ casualModal: false })}
                        backdrop="static"
                        keyboard={false}
                        centered={true}
                        size="lg"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Appointment Recurrence</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Card>
                            <Card.Title className="m-3">Workflow Notification</Card.Title>
                            <Card.Body>
                              <Form>
                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                  <Form.Label column sm="4">
                                    Start:{" "}
                                  </Form.Label>
                                  <Col sm="6">
                                    <Form.Control type="time" placeholder="Enter time" />
                                  </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                  <Form.Label column sm="4">
                                    Notification Before:{" "}
                                  </Form.Label>
                                  <Col sm="6">
                                    <Form.Control as="select" type="select">
                                      <option value="0">Select in minutes</option>
                                      {this.state.minutes.map((element) => {
                                        return (
                                          <option key={element} value={element}>
                                            {element}
                                          </option>
                                        );
                                      })}
                                    </Form.Control>
                                  </Col>
                                </Form.Group>
                              </Form>
                            </Card.Body>
                          </Card>

                          <Card className="mt-3">
                            <Card.Title className="m-3">Recurrence pattern</Card.Title>
                            <Card.Body>
                              <Row>
                                <Col sm={3}>
                                  <Form>
                                    <Form.Check
                                      type="radio"
                                      label="Daily"
                                      name="input"
                                      value="Daily"
                                      checked={this.state.casualInput === "Daily"}
                                      onChange={(e) => this.setState({ casualInput: e.target.value })}
                                    />
                                    <Form.Check
                                      type="radio"
                                      label="Weekly"
                                      name="input"
                                      value="Weekly"
                                      checked={this.state.casualInput === "Weekly"}
                                      onChange={(e) => this.setState({ casualInput: e.target.value })}
                                    />
                                    <Form.Check
                                      type="radio"
                                      label="Monthly"
                                      name="input"
                                      value="Monthly"
                                      checked={this.state.casualInput === "Monthly"}
                                      onChange={(e) => this.setState({ casualInput: e.target.value })}
                                    />
                                    <Form.Check
                                      type="radio"
                                      label="Yearly"
                                      name="input"
                                      value="Yearly"
                                      checked={this.state.casualInput === "Yearly"}
                                      onChange={(e) => this.setState({ casualInput: e.target.value })}
                                    />
                                  </Form>
                                </Col>

                                <Col sm={7}>
                                  {this.state.casualInput === "Daily" && (
                                    <Form>
                                      <Row>
                                        <Col sm={3}>
                                          <Form.Check
                                            type="checkbox"
                                            label="Sunday"
                                            name="Sunday"
                                            checked={this.state.Sunday}
                                            onChange={this.onChange}
                                          />
                                          <Form.Check
                                            type="checkbox"
                                            label="Thursday"
                                            name="Thursday"
                                            checked={this.state.Thursday}
                                            onChange={this.onChange}
                                          />
                                        </Col>
                                        <Col sm={3}>
                                          <Form.Check
                                            type="checkbox"
                                            label="Monday"
                                            name="Monday"
                                            checked={this.state.Monday}
                                            onChange={this.onChange}
                                          />
                                          <Form.Check
                                            type="checkbox"
                                            label="Friday"
                                            name="Friday"
                                            checked={this.state.Friday}
                                            onChange={this.onChange}
                                          />
                                        </Col>
                                        <Col sm={3}>
                                          <Form.Check
                                            type="checkbox"
                                            label="Tuesday"
                                            name="Tuesday"
                                            checked={this.state.Tuesday}
                                            onChange={this.onChange}
                                          />
                                          <Form.Check
                                            type="checkbox"
                                            label="Saturday"
                                            name="Saturday"
                                            checked={this.state.Saturday}
                                            onChange={this.onChange}
                                          />
                                        </Col>
                                        <Col sm={3}>
                                          <Form.Check
                                            type="checkbox"
                                            label="Wednesday"
                                            name="Wednesday"
                                            checked={this.state.Wednesday}
                                            onChange={this.onChange}
                                          />
                                        </Col>
                                      </Row>
                                    </Form>
                                  )}
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="info">OK</Button>
                          <Button variant="secondary" onClick={() => this.setState({ casualModal: false })}>
                            Cancel
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.releaseNewVersion ? (
              <div id="popup" className="overlay">
                <div className="popup createnewversion" style={{ width: "60%" }}>
                  <div className="content">
                    <div className="card m-b-30">
                      <div className="card-header bg-white heading-cont">
                        <h4>Create New Version</h4>
                        <div onClick={() => this.setState({ releaseNewVersion: false })}>
                          <svg
                            className="bi bi-x-circle-fill"
                            width="1em"
                            height="1em"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                      </div>

                      <div className="card-body pt-3">
                        <div className="form-group">
                          <h5 className="mb-1">
                            Last Created Version : <span>{this.state.lastversion}</span>
                          </h5>
                          {this.state.lastpublished ? (
                            <h6 className="text-black">
                              Last Published Version : <span>{this.state.lastpublished}</span>
                            </h6>
                          ) : (
                            <p className="text-danger py-1 pb-2">No Version Released. </p>
                          )}
                        </div>

                        <div className="form-group pt-3">
                          <label for="exampleInputEmail1">Enter New Version</label>
                          <input
                            type="number"
                            step="0.1"
                            onChange={this.onChangeInput}
                            name="version"
                            className="form-control"
                            placeholder="Enter New Version"
                          />
                          {errors.version.length > 0 && <span className="text-danger">{errors.version}</span>}
                        </div>
                        <p className="pt-3">Import Previous Version -</p>
                        <div className="mt-2 ver-list">
                          <div className="item">
                            <div className="custom-control custom-radio">
                              <input
                                type="radio"
                                id={`customRadio01`}
                                value={0}
                                onChange={this.radioVersionSelect}
                                name="mcqBankRadio"
                                className="custom-control-input"
                              />
                              <label className="custom-control-label" for={`customRadio01`}>
                                Create New
                              </label>
                            </div>
                          </div>
                          {this.state.allWorkFlowList.map((list, index) => (
                            <div className="item">
                              <div className="custom-control custom-radio">
                                <input
                                  type="radio"
                                  id={`customRadio${index + 10}`}
                                  value={list.id}
                                  onChange={this.radioVersionSelect}
                                  name="mcqBankRadio"
                                  className="custom-control-input"
                                />
                                <label className="custom-control-label" for={`customRadio${index + 10}`}>
                                  {list.version}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <button onClick={this.submitRelease} className="btn btn-primary mt-3">
                          Create
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </>
        ) : (
          <>
            <AssignedWorkedFlow newVersion={this.state.allWorkFlowList} taskCreate={(list) => this.taskCreate(list)} />
          </>
        )}

        <ScheduleRecurrenceModal
          show={this.state.showModal}
          scheduleData={this.state.schedule}
          workflow_id={sessionStorage.getItem("selected_workflow")}
          onClose={() => this.closeModal()}
          getWorkflowSchedule= {this.getWorkflowSchedule}
        />

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.userData,
});

// export default ListWorkflowVersion;
export default withRouter(connect(mapStateToProps)(ListWorkflowVersion));

const validateForm = (errors) => {
  let valid = true;
  Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
  return valid;
};
